import NotificationHubConnection from '../NotificationHubConnection'

class BarcodeGroup {
  joinBarcodeGroup (onBarcodeReceived) {
    NotificationHubConnection.on('BarcodeReceived', (args) => {
      console.log('onBarcodeReceived ' + args.data)
      onBarcodeReceived(args)
    })

    NotificationHubConnection.invoke('JoinBarcodeGroup')
      .then(() => console.log('Barcode group joined'))
      .catch(() => console.log('Fail to join barcode group'))
  }

  leaveBarcodeGroup () {
    NotificationHubConnection.off('BarcodeReceived')
    NotificationHubConnection.invoke('LeaveBarcodeGroup')
      .then(() => console.log('Barcode group left'))
      .catch(() => console.log('Fail to leave barcode group'))
  }
}

export default new BarcodeGroup()



// WEBPACK FOOTER //
// ./src/hub/groups/BarcodeGroup.js